/** @jsx jsx */

import { useState } from 'react';
import { css, jsx } from '@emotion/core';

export const Heart = props => {
  const { styles } = props;

  return (
    <g>
      <path
        css={css(styles)}
        d="M10.1,0.1C8.1-0.1,6.8,1.5,6.4,2.2C6,1.5,4.7-0.1,2.8,0.1C-0.1,0.4-0.7,3.6,1.2,6c1.5,2.1,5.2,6,5.3,6.1v0  c0,0,0,0,0,0c0,0,0,0,0,0v0c0.1-0.1,3.7-4,5.3-6.1C13.5,3.6,12.9,0.4,10.1,0.1z"
      />
    </g>
  );
};

export const heart = (
  <g>
    <path d="M10.1,0.1C8.1-0.1,6.8,1.5,6.4,2.2C6,1.5,4.7-0.1,2.8,0.1C-0.1,0.4-0.7,3.6,1.2,6c1.5,2.1,5.2,6,5.3,6.1v0  c0,0,0,0,0,0c0,0,0,0,0,0v0c0.1-0.1,3.7-4,5.3-6.1C13.5,3.6,12.9,0.4,10.1,0.1z" />
  </g>
);
